import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vant from 'vant';

import 'vant/lib/index.css'
import ElementUI from 'element-ui'; // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css'; // 2.2引入样式
import less from 'less'
// 使用组件
import VueVideoPlayer from 'vue-video-player'
// 引入样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import HelloWorld from './components/HelloWorld.vue'
import FootIndex from './components/FootIndex.vue'
import VueAMap from 'vue-amap'

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'af4ac700f15eab55094a78367023fa17',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation', 'AMap.HeatMap', 'AMap.DistrictSearch'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})
Vue.component('HelloWorld', HelloWorld)
Vue.component('FootIndex', FootIndex)
Vue.use(VueVideoPlayer)
Vue.use(less)
Vue.use(Vant);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$timeCycle = function (timestamp) {
  const date = new Date(timestamp * 1000) // 时间戳转 Date 对象（假设传入的是秒级时间戳）
  // 补零函数
  const padZero = (num) => num.toString().padStart(2, '0')
  // 返回 YYYY-MM-DD HH:MM:SS 格式
  return `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`
}
Vue.use(VueAxios, axios)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
